<app-spinner-container [isLoading]="tableNomprCertiffourComponent?.isLoading">
    <div class="cp5" fxLayout="column">
        <div fxFlex="100" fxFlex.lt-md="100">
            <app-filter-nompren-certif (search)="onSearch($event)" [acheteur]="acheteur"></app-filter-nompren-certif>
        </div>
        <div *ngIf="searchh.results!=[] && searchh.results!=null && searchh.results!=undefined" fxFlex="100"
             fxFlex.lt-md="100">
            <mat-card appCard class="table-card">
                <mat-card-content>

                    <app-table-nompr-certiffour #tableNomprCertiffourComponent (sort)="onSort($event)"
                                                [acheteur]="acheteur" [bizRegNo]="bizRegNo"
                                                [certif]="searchh.results"></app-table-nompr-certiffour>
                    <app-paginator
                            (paginate)="onPaginate($event)"
                            [total]="searchh.count"
                    ></app-paginator>
                </mat-card-content>
            </mat-card>
        </div>
        <div *ngIf="bizRegNo" class="mt-2" fxLayout="row" fxLayoutAlign="end center">
            <button (click)="enregistrer()" color="primary" mat-raised-button>
                {{"Nouvel enregistrement"|translate}}
            </button>

        </div>

    </div>
</app-spinner-container>
